module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shopEnter"
  }, [_c('div', {
    staticClass: "shopTop"
  }, [_c('div', {
    staticClass: "topLeft"
  }, [_c('div', {
    staticClass: "login",
    on: {
      "click": _vm.goLogin
    }
  }, [_vm._v("亲，请登录")]), _vm._v(" "), _c('div', {
    staticClass: "register",
    on: {
      "click": _vm.goRegister
    }
  }, [_vm._v("免费注册")]), _vm._v(" "), _c('div', {
    staticClass: "home",
    on: {
      "click": _vm.goHome
    }
  }, [_vm._v("首页")])]), _vm._v(" "), _c('div', {
    staticClass: "topRight"
  }, [_c('div', {
    staticClass: "aboutUs",
    on: {
      "click": _vm.goAboutUs
    }
  }, [_vm._v("关于我们")]), _vm._v(" "), _c('div', {
    staticClass: "contactUs",
    on: {
      "click": _vm.goContactUs
    }
  }, [_vm._v("联系我们")]), _vm._v(" "), _c('div', {
    staticClass: "news",
    on: {
      "click": _vm.goNews
    }
  }, [_vm._v("资讯")]), _vm._v(" "), _c('div', {
    staticClass: "enter",
    on: {
      "click": _vm.goEnter
    }
  }, [_vm._v("商家入驻")])])]), _vm._v(" "), _c('div', {
    staticClass: "shopSearch"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "search"
  }, [_c('el-input', {
    staticClass: "input-with-select",
    attrs: {
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.input3),
      callback: function($$v) {
        _vm.input3 = $$v
      },
      expression: "input3"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "enterFlow"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "flowCont"
  }, [_c('el-tabs', {
    staticClass: "flowTab",
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "01准备材料",
      "name": "first"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/tab1.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "02申请开店",
      "name": "second"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/tab2.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "03完成认证",
      "name": "third"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/tab3.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "04店铺上线",
      "name": "fourth"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/tab4.jpg"),
      "alt": ""
    }
  })])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "5rem"
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shopLogo"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/ejklogo_01.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shopLogo"
  }, [_c('img', {
    attrs: {
      "src": "",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shopGoods"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/shopEnter.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flowTitle"
  }, [_c('div', {
    staticClass: "title1"
  }, [_vm._v("普通商家入驻流程")]), _vm._v(" "), _c('div', {
    staticClass: "title2"
  }, [_vm._v("0费用低门槛开店无压力")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-183dd8af","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/page/shopPC/shopEnter.vue
// module id = 3215
// module chunks = 1